import React from "react";
import Api from "../../Assets/Services/Api.png";
import webApplication from "../../Assets/Services/web-application.png";
import firebase from "../../Assets/Services/firebase.jpg";
import webDesign from "../../Assets/Services/web-design.jpg";
import resume from "../../Assets/Services/Resume-writing.png";
import presentation from "../../Assets/Services/presentation.png";
import bugFix from "../../Assets/Services/Bug.jpg";
import wordpress from "../../Assets/Services/wrodpress.png";

const cardData = [
  {
    id: 1,
    title: "Web Design And Development",
    image: webDesign,
    desc: "website design and development will be using html5 css3 bootstrap and js",
    price: "45$",
  },
  {
    id: 2,
    title: "Web Application Development",
    image: webApplication,
    desc: "web application using react express node mongodb design with bootstrap & material ui",
    price: "150$",
  },
  {
    id: 3,
    title: "Web Application With Firebase Development",
    image: firebase,
    desc: "The firebase functionality will be used with react js and layouts design with bootstrap & material ui for the development",
    price: "55$",
  },
  {
    id: 4,
    title: "Restful API's Development",
    image: Api,
    desc: "Restful API's stuctures and design development using express js node js and firebase",
    price: "120$",
  },
  {
    id: 5,
    title: "Wordpress Website Development",
    image: wordpress,
    desc: "All type of website can be build with cms using the wordpress and woo commerce",
    price: "50$",
  },
  {
    id: 6,
    title: "Website Bug Fixing",
    image: bugFix,
    desc: "Any type of bug in the website using the technologies I have provided you will be fixed and maintained",
    price: "30$",
  },
  {
    id: 7,
    title: "Resume Writing",
    image: resume,
    desc: "If you want to make your cv or resume for tech industry for internship and job I will make you cv or resume",
    price: "10$",
  },
  {
    id: 8,
    title: "Presentation Making",
    image: presentation,
    desc: "If you want to make any type of presentation in powerpoint or pdf with visual effect and automate timing I will do this for you",
    price: "44$",
  },
];

const ServicesPage = () => {
  return (
    <div>
      <div className="container">
        <div className="row">
          {cardData.map((card, index) => (
            <div className="col-6 col-lg-3" key={index}>
              <div
                className="card shadow-box-2 bg-dark"
                style={{
                  color: "white",
                  height: "24.5rem",
                }}
              >
                <img
                  src={card.image}
                  className="card-img-top"
                  alt="..."
                  height="auto"
                  width="100%"
                />
                <div className="card-body">
                  <h6 className="card-title">{card.title}</h6>
                  <p className="small-text">{card.desc}</p>
                  {/* <a href="#" className="btn btn-primary">
                    Check Out
                  </a> */}{" "}
                  <br />
                  <p className="card-text text-end">
                    Starting at <b>{card.price}</b>
                  </p>
                </div>
              </div>
              <br />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;
